import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import ProductFeatureComponent from '../@shared/productFeatureComponent';
import { TProductFeatureComponentProps } from '../@shared/productFeatureComponent/types/productFeatureComponent.types';
import { seriesFeatureDetailOpen } from '../../constants/analytics.constants';
import { titleKeySeriesFeature } from '../../constants/dictionary.constants';

const ProductSeriesDetailFeature = (props: TProductFeatureComponentProps) => {
  return (
    <AnalyticsVisibleEvent event="series_features_visible">
      <ProductFeatureComponent
        {...props}
        isSeries={true}
        cardCTAVisibleEvent={seriesFeatureDetailOpen}
        titleDictionaryKeyFeature={titleKeySeriesFeature}
      />
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(ProductSeriesDetailFeature);
